export const LABELS = {
  LINE_1: 'Logradouro',
  LINE_2: 'Número',
  LINE_3: 'Complemento',
  LINE_4: 'Bairro',
  ZIP_CODE: 'CEP',
  CITY: 'Cidade',
  STATE: 'Estado',
  COUNTRY: 'País',
};

export const PLACEHOLDERS = {
  LINE_1: 'Nome da rua, avenida, etc',
  LINE_2: 'Número',
  LINE_3: 'Complemento (apartamento, casa...)',
  LINE_4: 'Nome do bairro',
  ZIP_CODE: 'Número do CEP',
  CITY: 'Nome da Cidade',
  STATE: 'Nome do Estado',
  COUNTRY: 'Nome do País',
};



// WEBPACK FOOTER //
// ./src/features/people/employees/components/step2/step2Constants.js